// Organizer panel API, admin copy of the web app's
// src/Organizer/Oireachtas/api.js (Devin 2026-09-26: the same panel in admin).
// The backend's organizer allowlist admits an admin as well as the event's own
// organizer, so these are the same calls. Every call is a GET except the team
// regional-approval mark, the organizer's checklist that nothing else reads.
import axios from 'axios';
import { serviceConsumer } from '../../network/ServiceConsumer';

const BASE = () => `${process.env.REACT_APP_BASE_URL}/oireachtas`;

export const getOrganizerSummary = (id) => serviceConsumer('GET', `${BASE()}/${id}/organizer-summary`);
export const getCompetitors = (id) => serviceConsumer('GET', `${BASE()}/${id}/competitors`);
export const getTeamRosters = (id) => serviceConsumer('GET', `${BASE()}/${id}/reports/teams`);
// one competition's entrants (draw order + numbers once the draw is locked)
export const getCompetitionList = (id, compId) =>
  serviceConsumer('GET', `${BASE()}/${id}/reports/competitors`, { comp: compId });
export const getTransactions = (id) => serviceConsumer('GET', `${BASE()}/${id}/reports/transactions`);
export const getReconciliation = (id) => serviceConsumer('GET', `${BASE()}/${id}/reports/reconciliation`);
// the read-only event-day Status: where each competition is, no names (card f4270e09)
export const getOrganizerStatus = (id) => serviceConsumer('GET', `${BASE()}/${id}/organizer-status`);
export const setTeamApproval = (id, teamId, approved) =>
  serviceConsumer('PUT', `${BASE()}/${id}/teams/${teamId}/regional-approval`, { approved });

// CSV/PDF downloads need the same auth headers as every API call, so they go
// through axios as a blob rather than a plain link.
export async function download(id, path, filename) {
  const res = await axios.get(`${BASE()}/${id}/${path}`, {
    responseType: 'blob',
    headers: {
      Authorization: 'Basic ' + window.btoa(`${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`),
      accesstoken: localStorage.getItem('accessToken'),
    },
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
